import { render, staticRenderFns } from "./click_heatmap.vue?vue&type=template&id=2b16b34a&scoped=true&lang=pug&"
import script from "./click_heatmap.vue?vue&type=script&lang=js&"
export * from "./click_heatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b16b34a",
  null
  
)

export default component.exports